import React, { useState, useEffect } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useFilters,
} from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ExpandableTableBranches.css";
import TableHeader from "../../../Components/UiComponents/Table/TableHeader/TableHeader";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import SvgSortdownarrow from "../../../Components/IconComponents/Sortdownarrow";
import SvgSortuparrow from "../../../Components/IconComponents/Sortuparrow";
import SvgSorting from "../../../Components/IconComponents/Sortingarrow";
import { getData } from "../../../Services/Services";
import { getJobTitle, getThemeURL } from "../../../Services/EndPoints";
import { toast } from "react-toastify";
import {
  DeleteConvgIcon,
  EditConvgIcon,
} from "../../../Components/IconComponents";
import { useNavigate } from "react-router-dom";

// Default filter UI for a column
const DefaultColumnFilter = ({ column: { filterValue, setFilter } }) => {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // undefined to remove the filter entirely
      }}
      placeholder={`Filter...`}
      style={{
        width: "100%",
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        marginTop: "5px",
      }}
    />
  );
};

//Expandable Table function for branch details
const ExpandableTableBranches = (props) => {
  const {
    columns,
    data,
    numberOfRows,
    headerTableHeadStyle = {},
    tableStyle = {},
    showRowCount = true,
    rowCount,
    setSearchData = () => {},
    enableColumnFilters = false,
    disbalePaginationFilter = false,
    disbalePaginationFilter1 = false,
    disbalePaginationFilter2 = false,
  } = props;

  // Track two levels of expansion - bank entities and branches
  const [expandedBankIds, setExpandedBankIds] = useState({});
  const [expandedBranchIds, setExpandedBranchIds] = useState({});
  const [jobTitleList, setJobTitleList] = useState([]);
  
  // User permissions state
  const [userPermissions, setUserPermissions] = useState({
    canEdit: false,
    canDelete: false,
  });
  
  const navigate = useNavigate();

  

  // Parse web permissions from user profile
  const parseUserPermissions = (permissions) => { 
  if (!permissions || !Array.isArray(permissions)) {
    return { canView: false, canEdit: false, canDelete: false };
  }

  // Find the permission with ID 5 for "All Branches" functionality
  const hasPermission = permissions.find(permission => permission.id === 5);
  console.log("Branch permission found:", hasPermission);
  
  if (!hasPermission || !hasPermission.web_permissions) {
    return { canView: false, canEdit: false, canDelete: false };
  }

  // Parse web_permissions string (e.g., "V,E,D" or "V" or "V,E")
  const webPermissions = hasPermission.web_permissions.split(',').map(p => p.trim());
  
  const result = {
    canView: webPermissions.includes('V'),
    canEdit: webPermissions.includes('E'),
    canDelete: webPermissions.includes('D'),
  };
  
  return result;
};

  // Fetch user profile to determine permissions
  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        // Parse and set user permissions
        const permissions = parseUserPermissions(userProfile[0].permissions);
        setUserPermissions(permissions);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    fetchJobtitle();
    getUserProfile(); // Fetch user permissions on component mount
  }, []);

  // Toggle expansion for the bank row
  const toggleBankExpansion = (rowId) => {
    setExpandedBankIds((prev) => {
      const isCurrentlyExpanded = !!prev[rowId];
      return isCurrentlyExpanded ? {} : { [rowId]: true };
    });
  };

  // Toggle expansion for branch details
  const toggleBranchExpansion = (branchId) => {
    setExpandedBranchIds((prev) => {
      const isCurrentlyExpanded = !!prev[branchId];

      // If we're expanding this branch, close all others within the same bank
      if (!isCurrentlyExpanded) {
        return { [branchId]: true };
      }
      // Otherwise, just close this branch
      else {
        const newState = { ...prev };
        delete newState[branchId];
        return newState;
      }
    });
  };

  // Render active status indicator
  const renderActiveStatus = (status) => {
    return status === true ? (
      <div
        className="status-indicator active"
        title="Active"
        style={{
          backgroundColor: "#15d1A4",
          color: "white",
          width: "25px",
          height: "25px",
          borderRadius: "4px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        ✓
      </div>
    ) : (
      <div
        className="status-indicator inactive"
        title="Inactive"
        style={{
          backgroundColor: "#FF5733",
          color: "white",
          width: "25px",
          height: "25px",
          borderRadius: "4px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        ✕
      </div>
    );
  };

  const {
  getTableProps,
  getTableBodyProps,
  headerGroups,
  prepareRow,
  page,
  canPreviousPage,
  canNextPage,
  pageOptions,
  gotoPage,
  nextPage,
  previousPage,
  setPageSize,
  setGlobalFilter,
  rows,
  state: { pageIndex, globalFilter, pageSize },
} = useTable(
  {
    columns,
    data,
    defaultColumn: { Filter: DefaultColumnFilter },
    initialState: { pageIndex: 0, pageSize: numberOfRows },
    globalFilter: (rows, columnIds, filterValue) => {
      if (!filterValue) return rows;
      
      const searchTerm = filterValue.toLowerCase();
      
      return rows.filter(row => {
        const original = row.original;
        
        // Search in main row data (bank)
        const mainRowMatch = 
          (original.bankName && original.bankName.toLowerCase().includes(searchTerm)) ||
          (original.ifscCode && original.ifscCode.toLowerCase().includes(searchTerm)) ||
          (original.district && original.district.toLowerCase().includes(searchTerm)) ||
          (original.city && original.city.toLowerCase().includes(searchTerm)) ||
          (original.mandal && original.mandal.toLowerCase().includes(searchTerm)) ||
          (original.phoneNumber && original.phoneNumber.includes(searchTerm)) ||
          (original.email && original.email.toLowerCase().includes(searchTerm)) ||
          // ADD ADDRESS SEARCH FOR BANKS
          (original.addressLine1 && original.addressLine1.toLowerCase().includes(searchTerm)) ||
          (original.addressLine2 && original.addressLine2.toLowerCase().includes(searchTerm));
        
        // Search in branch data (expanded content)
        const branchMatch = original.branchDetailsList && 
          original.branchDetailsList.some(branch => 
            (branch.branchName && branch.branchName.toLowerCase().includes(searchTerm)) ||
            (branch.ifscCode && branch.ifscCode.toLowerCase().includes(searchTerm)) ||
            (branch.district && branch.district.toLowerCase().includes(searchTerm)) ||
            (branch.city && branch.city.toLowerCase().includes(searchTerm)) ||
            (branch.mandal && branch.mandal.toLowerCase().includes(searchTerm)) ||
            (branch.phoneNumber && branch.phoneNumber.includes(searchTerm)) ||
            (branch.email && branch.email.toLowerCase().includes(searchTerm)) ||
            // ADD ADDRESS SEARCH FOR BRANCHES
            (branch.addressLine1 && branch.addressLine1.toLowerCase().includes(searchTerm)) ||
            (branch.addressLine2 && branch.addressLine2.toLowerCase().includes(searchTerm)) ||
            // Search in branch contact details
            (branch.branch_contact && branch.branch_contact.some(contact =>
              (contact.firstName && contact.firstName.toLowerCase().includes(searchTerm)) ||
              (contact.lastName && contact.lastName.toLowerCase().includes(searchTerm)) ||
              (contact.email && contact.email.toLowerCase().includes(searchTerm)) ||
              (contact.phoneNumber && contact.phoneNumber.includes(searchTerm))
            ))
          );
        
        return mainRowMatch || branchMatch;
      });
    },
  },
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination
);

  const { t } = useTranslation();

  const translateNumber = (number) => {
    const numberString = number.toString();
    return i18n.t(`numbers.${numberString}`, { defaultValue: numberString });
  };

  let tempRowCount = globalFilter ? rows.length : rowCount || data.length;
  let tempPageIndex = pageIndex;
  let tempPageSize = pageSize;

  if (tempPageIndex === undefined || tempPageIndex === null) {
    tempPageIndex = 0;
  }
  if (tempRowCount === undefined || tempRowCount === null) {
    tempRowCount = 0;
  }
  if (tempPageSize === undefined || tempPageSize === null) {
    tempPageSize = 10;
  }

  const startIndex = tempPageIndex * tempPageSize + 1 || 1;
  const endIndex =
    Math.min((tempPageIndex + 1) * tempPageSize, tempRowCount) || tempRowCount;

  const translatedStartIndex = startIndex;
  const translatedEndIndex = endIndex;
  const translatedRowCount = tempRowCount;

  useEffect(() => {
    setPageSize(numberOfRows);
  }, [numberOfRows]);

  useEffect(() => {
    if (globalFilter) {
      const pageData = page?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    } else {
      const pageData = rows?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    }
  }, [globalFilter, rows]);

  const fetchJobtitle = async () => {
    // setLoader(true);
    try {
      const response = await getData(getJobTitle);
      if (response && Array.isArray(response)) {
        setJobTitleList(response);
      } else {
        console.error("Unexpected job titles response format:", response);
        toast.error("Failed to load job titles.");
      }
    } catch (error) {
      console.error("Error fetching job titles:", error);
      toast.error("Failed to load job titles.");
    } finally {
      // setLoader(false);
    }
  };

  // Render branches for a bank entity
  const renderBranchesRow = (row) => {
    const branches = row.original.branchDetailsList || [];

    return (
      <tr>
        <td colSpan={columns.length + 1}>
          <div
            className="branches-container"
            style={{
              marginLeft: "50px",
              marginTop: "10px",
              marginBottom: "10px",
              width: "95%",
            }}
          >
            <h6
              style={{
                marginLeft: "-10px",
                fontWeight: "600",
                color: "#1a7a73",
              }}
            >
              Branch Details
            </h6>

            {branches.length > 0 ? (
              <table
                className="table"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  position: "sticky",
                }}
              >
                <thead style={{ backgroundColor: "#1a7a73" }}>
                  <tr>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        color: "white",
                        width: "30px",
                      }}
                    ></th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      Branch Name
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      IFSC Code
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      Phone Number
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      Address
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      Mandal
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      City
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      District
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      Active Status
                    </th>
                    {/* Only show Actions header if user has edit or delete permissions */}
                    {(userPermissions.canEdit || userPermissions.canDelete) && (
                      <th
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Actions
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {branches.map((branch) => (
                    <React.Fragment key={branch.id}>
                      <tr style={{ backgroundColor: "#f2f2f2" }}>
                        <td style={{ textAlign: "left" }}>
                          <span
                            onClick={() => toggleBranchExpansion(branch.id)}
                            style={{ cursor: "pointer", fontSize: "18px" }}
                          >
                            {expandedBranchIds[branch.id] ? "-" : "+"}
                          </span>
                        </td>
                        <td style={{ padding: "8px", textAlign: "left" }}>
                          {branch.branchName || "NA"}
                        </td>
                        <td style={{ padding: "8px", textAlign: "left" }}>
                          {branch.ifscCode || "NA"}
                        </td>
                        <td style={{ padding: "8px", textAlign: "left" }}>
                          {branch.phoneNumber || "NA"}
                        </td>
                        <td style={{ padding: "8px", textAlign: "left" }}>
                          {branch.addressLine1 +
                            (branch.addressLine2
                              ? ", " + branch.addressLine2
                              : "") || "NA"}
                        </td>
                        <td style={{ padding: "8px", textAlign: "left" }}>
                          {branch.mandal || "NA"}
                        </td>
                        <td style={{ padding: "8px", textAlign: "left" }}>
                          {branch.city || "NA"}
                        </td>
                        <td style={{ padding: "8px", textAlign: "left" }}>
                          {branch.district || "NA"}
                        </td>
                        <td style={{ padding: "8px", textAlign: "left" }}>
                          {renderActiveStatus(branch.activeStatus)}
                        </td>
                        {/* Only show Actions column if user has edit or delete permissions */}
                        {(userPermissions.canEdit || userPermissions.canDelete) && (
                          <td>
                            {/* Edit button - only show if user has edit permission */}
                            {userPermissions.canEdit && (
                              <span
                                onClick={() =>
                                  navigate("/branches/add-branch", {
                                    state: {
                                      dataForEdit: row.original,
                                      branchData: branch,
                                      edit: true,
                                    },
                                  })
                                }
                              >
                                <EditConvgIcon
                                  value={props.value}
                                  className="cursor-pointer me-2"
                                />
                              </span>
                            )}

                            {/* Delete button - only show if user has delete permission */}
                            {userPermissions.canDelete && (
                              <span
                                // onClick={() => !isDisabled && deletePopUp()}
                                style={{
                                  cursor: "not-allowed",
                                  opacity: 0.5,
                                  pointerEvents: "none", // disables clicks
                                }}
                              >
                                <DeleteConvgIcon
                                  value={props.value}
                                  className="cursor-pointer mr-1"
                                />
                              </span>
                            )}
                          </td>
                        )}
                      </tr>

                      {expandedBranchIds[branch.id] &&
                        renderBranchDetails(branch)}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ textAlign: "center", padding: "10px" }}>
                No branches available
              </p>
            )}
          </div>
        </td>
      </tr>
    );
  };

  // Render details for a specific branch
  const renderBranchDetails = (branch) => {
    const branchContacts = branch.branch_contact || [];
    const workingHours = branch.branch_work_time || [];

    // Function to find the job title by ID
    const getJobTitleName = (jobTitleId) => {
      if (!jobTitleId) return "NA";
      const jobTitle = jobTitleList.find((job) => job.id === jobTitleId);
      return jobTitle ? jobTitle.value : "NA";
    };

    const formatTime = (timeString) => {
      if (!timeString) return "NA";

      try {
        // If the time is in format HH:MM:SS, just take HH:MM
        if (timeString.match(/^\d{1,2}:\d{2}:\d{2}$/)) {
          return timeString.substring(0, 5);
        }

        // If it's already in HH:MM format
        if (timeString.match(/^\d{1,2}:\d{2}$/)) {
          // Make sure hours are padded with leading zero if needed
          const [hours, minutes] = timeString.split(":");
          return `${hours.padStart(2, "0")}:${minutes}`;
        }

        // For other formats, try to extract hours and minutes
        const timeRegex = /(\d{1,2}):(\d{2})(?::(\d{2}))?(?:\s*(AM|PM|am|pm))?/;
        const match = timeString.match(timeRegex);

        if (match) {
          let [_, hours, minutes, __, period] = match;
          hours = parseInt(hours, 10);

          // Convert to 24-hour format if AM/PM is present
          if (period) {
            if (period.toLowerCase() === "pm" && hours < 12) {
              hours += 12;
            } else if (period.toLowerCase() === "am" && hours === 12) {
              hours = 0;
            }
          }

          return `${hours.toString().padStart(2, "0")}:${minutes}`;
        }

        return timeString; // Return original if no patterns match
      } catch (error) {
        console.error("Error formatting time:", error);
        return timeString; // Return original if parsing fails
      }
    };

    return (
      <tr>
        <td colSpan="7">
          <div
            style={{
              width: "90%",
              marginLeft: "60px",
              marginTop: "10px",
              marginBottom: "15px",
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            {/* Branch Contacts Table - Left Side */}
            <div style={{ width: "48%" }}>
              <h6
                style={{
                  marginLeft: "10px",
                  fontWeight: "600",
                  color: "#1a7a73",
                }}
              >
                Contact Details
              </h6>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#1a7a73" }}>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        color: "white",
                      }}
                    >
                      Name
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        color: "white",
                      }}
                    >
                      Job Title
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        color: "white",
                      }}
                    >
                      Email Address
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        color: "white",
                      }}
                    >
                      Phone Number
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {branchContacts.length > 0 ? (
                    branchContacts.map((contact) => (
                      <tr key={contact.id}>
                        <td
                          style={{
                            padding: "10px",
                            textAlign: "left",
                            borderBottom: "1px solid gray",
                          }}
                        >
                          {`${contact.firstName} ${contact.lastName}` || "NA"}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            textAlign: "left",
                            borderBottom: "1px solid gray",
                          }}
                        >
                          {getJobTitleName(contact.job_title_id)}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            textAlign: "left",
                            borderBottom: "1px solid gray",
                          }}
                        >
                          {contact.email || "NA"}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            borderBottom: "1px solid gray",
                          }}
                        >
                          {contact.phoneNumber || "NA"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        style={{ textAlign: "center", padding: "10px" }}
                      >
                        No contact information available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Working Hours Table - Right Side */}
            <div style={{ width: "48%" }}>
              <h6
                style={{
                  marginLeft: "148px",
                  fontWeight: "600",
                  color: "#1a7a73",
                }}
              >
                Branch Working Hours
              </h6>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginLeft: "108px",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#1a7a73" }}>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        color: "white",
                      }}
                    >
                      Day
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        color: "white",
                      }}
                    >
                      From Time
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        color: "white",
                      }}
                    >
                      To Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {workingHours.length > 0 ? (
                    workingHours.map((hours) => (
                      <tr key={hours.id}>
                        <td
                          style={{
                            padding: "10px",
                            textAlign: "left",
                            borderBottom: "1px solid gray",
                          }}
                        >
                          {hours.day || "NA"}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            textAlign: "left",
                            borderBottom: "1px solid gray",
                          }}
                        >
                          {formatTime(hours.fromTime)}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            borderBottom: "1px solid gray",
                          }}
                        >
                          {formatTime(hours.toTime)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="3"
                        style={{ textAlign: "center", padding: "10px" }}
                      >
                        No working hours information available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div className="tabl_container">
      <TableHeader
        {...props}
        searchValue={globalFilter || ""}
        onSearchHandler={setGlobalFilter}
      />
      <div className="iccc__table--container" style={tableStyle}>
        <table {...getTableProps()} className="table iccc--table">
          <thead style={{ backgroundColor: "#1a7a73" }}>
            <tr>
              <th
                style={{
                  width: "30px",
                  textAlign: "left",
                  color: "white",
                  backgroundColor: "#1a7a73",
                }}
              >
                {t("")}
              </th>
              {headerGroups.map((headerGroup, index) => (
                <React.Fragment key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      style={headerTableHeadStyle}
                      key={index}
                    >
                      {column.render("Header")}
                      {!column.disableSortBy &&
                        (column.isSorted ? (
                          column.isSortedDesc ? (
                            <SvgSortdownarrow />
                          ) : (
                            <SvgSortuparrow />
                          )
                        ) : (
                          <SvgSorting />
                        ))}
                      {enableColumnFilters && column.canFilter && (
                        <div>{column.render("Filter")}</div>
                      )}
                    </th>
                  ))}
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length > 0 ? (
              page.map((row, i) => {
                prepareRow(row);
                const isExpanded = expandedBankIds[row.id];

                return (
                  <React.Fragment key={row.id}>
                    <tr {...row.getRowProps()}>
                      <td style={{ textAlign: "left" }}>
                        <span
                          onClick={() => toggleBankExpansion(row.id)}
                          style={{ cursor: "pointer", fontSize: "18px" }}
                        >
                          {isExpanded ? "-" : "+"}
                        </span>
                      </td>
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          key={cell.column.id}
                          style={{ textAlign: "left" }}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                    {isExpanded && renderBranchesRow(row)}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length + 1} className="no-data-text">
                  No data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        {!disbalePaginationFilter2 && (
          <div className="float-start m-2 mt-2 ms-3">
            {showRowCount && (
              <div className="float-start m-2 mt-1 ms-3 pagecount-style">
                {t("showingentriestable.showing")} {translatedStartIndex}{" "}
                {t("showingentriestable.to")} {translatedEndIndex}{" "}
                {t("showingentriestable.of")} {translatedRowCount}{" "}
                {t("showingentriestable.entries")}
              </div>
            )}
          </div>
        )}
        <div className="pagination">
          {!disbalePaginationFilter && (
            <div className="d-flex">
              <span className="pagination_gotopage">
                Go to page:
                <input
                  type="number"
                  min="1"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    let pageNumber = Number(e.target.value);
                    if (pageNumber < 1 || isNaN(pageNumber)) {
                      pageNumber = 1; // Ensures minimum value of 1
                    }
                    gotoPage(pageNumber - 1);
                  }}
                  className="pagination_gotopage-input"
                />
              </span>
              <span>
                <select
                  className="pagination_select"
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[10, 50, 100, 500, 1000, 2000].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      show {pageSize}
                    </option>
                  ))}
                </select>
              </span>
            </div>
          )}
          {!disbalePaginationFilter1 && (
            <>
              <button
                className="pagebtn mx-2"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"<"}
              </button>
              <button className="pagination_page">
                {translateNumber(pageIndex + 1)}{" "}
              </button>
              <button
                className="pagebtn"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {">"}
              </button>{" "}
              <span className="right_pageno">
                {t("pagination.page_of", {
                  page: translateNumber(pageIndex + 1),
                  total: translateNumber(pageOptions.length),
                })}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpandableTableBranches;